export class OrbiFormId {
}
OrbiFormId.FormSchemaCookie = "FormSchemaCookie";
OrbiFormId.FormSchemaTest = "FormSchemaTest";
;
export class OrbiFormSchemaVerb {
}
OrbiFormSchemaVerb.Post = "Post";
OrbiFormSchemaVerb.Get = "Get";
OrbiFormSchemaVerb.Patch = "Patch";
;
;
;
